export const StudentWorks = (props) => {
  return (
    <div id="StudentWorks">
      <div class="container">
        <div className="section-title">
          <h2>Poema para Plataforma Horizonte</h2>
          {/*<p>
            Testimonios de padres y estudiantes acerca de <b>Horizonte</b>.
          </p>*/}
        </div>
        <blockquote style={{ borderColor: "#FF5500" }}>
          <div class="row">
            <i
              class="fa fa-quote-right fa-2x text-muted pull-right mt-3 mb-3"
              aria-hidden="true"
            ></i>
          </div>
          <div class="row" style={{ alignItems: "start" }}>
            <div class="col-xs-12 col-md-6">
              <p class="m-0 text-muted" style={{ fontSize: "1.7rem" }}>
                En la comodidad de mi hogar, un lugar especial,
                <br />
                Donde el conocimiento y el aprendizaje se hacen realidad.
                <br />
                Estudiar en casa, una experiencia genial,
                <br />
                Donde la mente se abre y el saber se vuelve vital.
                <br />
                <br />
                Con libros y recursos a mi alcance,
                <br />
                Exploro nuevos temas con entusiasmo y constancia.
                <br />
                Sin horarios fijos, puedo elegir mi propio ritmo,
                <br />
                Sumergiéndome en el conocimiento sin ningún abismo.
                <br />
                <br />
                En mi rincón de estudio, rodeado de calma,
                <br />
                Las ideas fluyen y la creatividad se desarma.
                <br />
                Puedo profundizar en cada materia con pasión,
                <br />
                Explorando nuevos horizontes en cada lección.
                <br />
                <br />
                La tecnología es mi aliada, mi compañera,
                <br />
                Con ella, el mundo entero se convierte en mi biblioteca.
                <br />
                Videos, tutoriales y recursos en línea,
                <br />
                Amplían mi visión y enriquecen mi rutina.
              </p>
            </div>
            <div class="col-xs-12 col-md-6">
              <p class="m-0 text-muted" style={{ fontSize: "1.7rem" }}>
                En casa encuentro un espacio de enfoque y tesoro.
                <br />
                La autodisciplina se convierte en mi guía,
                <br />
                Y el progreso en mis estudios se vuelve mi alegría.
                <br />
                <br />
                Estudiar en casa es un privilegio y un regalo,
                <br />
                Donde el aprendizaje se vuelve un viaje sin igual.
                <br />
                Aprovecho cada momento, cada instante,
                <br />
                Para crecer como persona y alcanzar mis metas brillantes.
                <br />
                <br />
                Así que celebro la oportunidad de estudiar en casa,
                <br />
                Un lugar donde el conocimiento se abraza.
                <br />
                Con dedicación y esfuerzo, alcanzaré mis sueños,
                <br />
                Y convertiré mi aprendizaje en verdaderos empeños.
                <br />
                <br />
                En casa, el estudio se vuelve una aventura,
                <br />
                Un camino hacia el éxito y la cultura.
                <br />
                Aprovecho cada día para aprender y crecer,
                <br />
                Porque estudiar en casa es algo que agradezco y aprecio sin
                querer.
              </p>
            </div>
          </div>
          <div class="row">
            <div
              class="small pull-right"
              style={{ marginTop: "20px", fontSize: "1.6rem" }}
            >
              Julián Stricker, Alumno de Horizonte
              {/*<cite>
                <b> Poema para Plataforma Horizonte</b>
        </cite>*/}
            </div>
          </div>
        </blockquote>
      </div>
    </div>
  );
};
